.ux-iws-discontinuation-tooltip {
    display: inline-block;

    ux-icon {
        margin-bottom: 3px;
        vertical-align: middle;
    }

    &__slot {
        display: none;
    }
}
